import React, { useContext, useState, useEffect, Fragment } from 'react';
import { Box, Flex, Text, Image, Heading } from '@chakra-ui/core';
import moment from 'moment';
import isEmpty from 'lodash/isEmpty';

import { ComponentContext } from '../../context/componentContext';
import { AuthContext } from '../../context/authContext';
import { FarmContext } from '../../context/farmContext';
import { OrderContext } from '../../context/orderContext';
import { ProductContext } from '../../context/productContext';

import UnexpectedError from '../../components/UnexpectedError';
import Summary from '../../components/Dashboard/home/Summary';
import StartFarm from '../../components/Dashboard/home/StartFarm';
import Tour from '../../components/Dashboard/home/Tour';
import AddFarm from '../../components/Dashboard/home/AddFarm';
import getGreetingTime from '../../utils/Greeting';
import PendingOrderCard from '../../components/Dashboard/home/PendingOrderCard';

//images
import Illustration from '../../images/farm-illustration.svg';

const Home = () => {
  document.title = 'CrowdFarmer | Dashboard';

  window.onbeforeunload = null;

  const { menuOpen, reload, unexpectedError, setUnexpectedError, setLoading } = useContext(
    ComponentContext
  );
  const { isAuthenticated, session, setSession } = useContext(AuthContext);
  const { fetchFarms, fetchActivities, fetchHistory } = useContext(FarmContext);
  const { getOrders, downloadPDF, deleteOrder } = useContext(OrderContext);
  const { getProducts } = useContext(ProductContext);

  const { user, token } = isAuthenticated();
  const { firstName } = user;

  const [farms, setFarms] = useState([]);
  const [history, setHistory] = useState({});
  const [orders, setOrders] = useState([]);
  const [products, setProducts] = useState([]);

  useEffect(() => {
    let mounted = true;
    if (session) {
      (async () => {
        setLoading(true);
        try {
          const [res1, res2, res3, res4] = await Promise.all([
            fetchFarms({ status: 'not-completed' }),
            fetchHistory(),
            getOrders({ status: 'not-processing' }),
            getProducts({ notStatus: 3 })
          ]);
          if (res1.code === 200) {
            if (mounted) setFarms(res1.data);
          } else setUnexpectedError('Unexpected Server Error!');
          if (res2.code === 200) {
            if (mounted) setHistory(res2.data);
          } else setUnexpectedError('Unexpected Server Error!');
          if (res3.code === 200) {
            if (mounted) setOrders(res3.data);
          } else setUnexpectedError('Unexpected Server Error!');
          if (res4.code === 200) {
            if (mounted) setProducts(res4.data);
          } else setUnexpectedError('Unexpected Server Error!');
        } catch (error) {
          if (error && error.status === 401) setSession(false);
          else setUnexpectedError('Unexpected Network Error!');
        }
        setLoading(false);
      })();
    }
    return () => (mounted = false);
  }, [
    reload,
    fetchFarms,
    fetchHistory,
    session,
    setLoading,
    setSession,
    setUnexpectedError,
    getOrders,
    getProducts
  ]);

  return (
    <Fragment>
      {unexpectedError ? (
        <UnexpectedError unexpectedError={unexpectedError} />
      ) : (
        <Box pt={40}>
          <Flex wrap="wrap" justify="space-between" px={{ base: 16, md: 20, lg: 48 }}>
            <Box>
              <Heading as="h3">
                {getGreetingTime(moment())},
                <br /> Farmer {firstName}
              </Heading>
            </Box>
            <Box mt={{ base: '10px', md: 0 }}>
              <Text fontSize={{ md: '20px' }}>
                Welcome to Complete Farmer! <br /> This is your home page, where you can quickly
                see,
                <br />
                select and manage your farms.
              </Text>
            </Box>
          </Flex>
          <Image
            src={Illustration}
            alt="Welcome Illustration"
            w="100%"
            objectFit="center"
            mt={{ base: 6, md: -6 }}
          />

          {!isEmpty(farms) ? (
            <Fragment>
              {!isEmpty(orders) && (
                <PendingOrderCard
                  orders={orders}
                  menuOpen={menuOpen}
                  session={session}
                  setSession={setSession}
                  setUnexpectedError={setUnexpectedError}
                  downloadPDF={downloadPDF}
                  deleteOrder={deleteOrder}
                  token={token}
                  firstName={firstName}
                />
              )}
              {!isEmpty(history) && <Summary menuOpen={menuOpen} history={history} />}
              <StartFarm
                farms={farms}
                menuOpen={menuOpen}
                setSession={setSession}
                setUnexpectedError={setUnexpectedError}
                fetchActivities={fetchActivities}
              />
              {!isEmpty(products) && (
                <Box bg="cf.100" py={10}>
                  <AddFarm menuOpen={menuOpen} products={products} />
                </Box>
              )}
            </Fragment>
          ) : (
            <Fragment>
              {/* <Tour /> */}
              {!isEmpty(products) && <AddFarm menuOpen={menuOpen} products={products} />}
            </Fragment>
          )}
        </Box>
      )}
    </Fragment>
  );
};

export default Home;
